
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/realtime",
      function () {
        return require("private-next-pages/content/qna/realtime/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/qna/realtime"])
      });
    }
  